import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface OsCustomApp {
  id: string;
  brand_id: string;
  name: string;
  description: string | null;
  icon_url: string | null;
  base_url: string;
  path_prefix: string;
  menu_position: number;
  menu_category: string | null;
  enabled: boolean;
  feature_key: string | null;
  created_at: string;
  updated_at: string;
}

export function useCustomApps(brandId: string | undefined) {
  return useQuery({
    queryKey: ['os_custom_apps', brandId],
    queryFn: async (): Promise<OsCustomApp[]> => {
      if (!brandId) return [];
      const { data, error } = await supabase
        .from('os_custom_apps')
        .select('*')
        .eq('brand_id', brandId)
        .eq('enabled', true)
        .order('menu_position', { ascending: true });
      if (error) throw error;
      return (data ?? []) as OsCustomApp[];
    },
    enabled: !!brandId,
  });
}
